import React from "react";
import MarkingCommon from './markingCommon';


// This is specialized for AK test socket object, but as for now, this is also for AK final socket object.
// Because for AK, test scket and final socket are basically same object. Just change thickness, etc.
const MarkingTest = () => {
  return (
    <>
      {/* MarkingCommon is common objects between test socket and final socket */}
      <MarkingCommon/>

      {/*
      { isTest ? <MTestCurve color={"deeppink"} axisMove={"z"} axisShow={"y"}/> : null }
      { isTest     ? <MSocket
                      meshSocket={meshSocketTrim} 
                    /> : null }
      */}
    </>
  );
};

export default MarkingTest;
